export * from "./normalizeStoreConfigResponse";
